import { useState } from "react";

const useSearch = (defaultValues = {}) => {
    const [pagination, setPagination] = useState({ skip: 0, top: 10 });
    const [condition, setCondition] = useState(defaultValues);
    const [params, setParams] = useState({ ...pagination, ...condition });

    const conditionHandler = source => {
        setCondition(source);
        setParams({ ...source, ...{ skip: 0, top: source.top }});
    };

    const pcaginationHandler = ({ skip, top }) => {
        pagination.top = top;
        pagination.skip = skip;
        setPagination(pagination);
        setParams({ ...condition, ...pagination });
    };

    return [params, conditionHandler, pcaginationHandler];
};

export default useSearch;
